import {IconName} from '@benchling/icons';
import {css, StyleDeclaration, StyleSheet} from 'aphrodite';
import React from 'react';

import {ERROR_LEVEL_TO_COLOR} from 'samples/plate-maps/PlateMapConstants';
import {PlateMapErrorLevel} from 'samples/plate-maps/validation/ValidationTypes';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const styles = StyleSheet.create({
  errorIcon: {color: ERROR_LEVEL_TO_COLOR[PlateMapErrorLevel.ERROR]},
  warningIcon: {color: ERROR_LEVEL_TO_COLOR[PlateMapErrorLevel.WARNING]},
  infoIcon: {color: ERROR_LEVEL_TO_COLOR[PlateMapErrorLevel.INFO]},
});

const ICON_BY_ERROR_LEVEL = {
  [PlateMapErrorLevel.ERROR]: {icon: 'exclamation-circle', iconStyles: styles.errorIcon},
  [PlateMapErrorLevel.WARNING]: {
    icon: 'exclamation-triangle',
    iconStyles: styles.warningIcon,
  },
  [PlateMapErrorLevel.INFO]: {icon: 'info-circle', iconStyles: styles.infoIcon},
} satisfies Record<PlateMapErrorLevel, {icon: IconName; iconStyles: StyleDeclaration}>;

interface ValidationIconProps {
  /** What level of error: ERROR, WARNING, or INFO */
  level: PlateMapErrorLevel;
  /** The size in pixels of the icon; will be used for height and width */
  size: number;
}

export default function ValidationIcon({level, size}: ValidationIconProps): JSX.Element {
  const {icon, iconStyles} = ICON_BY_ERROR_LEVEL[level];
  return (
    <BenchlingIcon
      icon={icon}
      className={css(iconStyles)}
      style={{height: `${size}px`, width: `${size}px`}}
    />
  );
}
